<template>
  <div class="products__product product" v-if="$store.getters['auth/isRole']('ROLE_AGENT') == true">
    <router-link
      v-if="item.id"
      :to="{ name: 'ProductDetail', params: { id: item.id } }"
      class="product__image-container"
    >
      <img
        class="product__image"
        alt=""
        v-if="item.photos[0]"
        :src="imagesurl + '600/' + item.photos[0].name"
      />
      <img v-else class="product__image" src="/static/img/600x400.jpg" alt="" />
    </router-link>
    <div class="product__info-container">
      <div class="product__info-main">
        <div class="product__name-container">
          <h3 class="product__name">{{ item.label | truncate(30, "...") }}</h3>
        </div>
        <div class="product__price-container">
          <div v-for="productPrice in item.prices">
            <span class="product__price" v-if="productPrice.entrepriseDescription == 'MCI'"
              ><strong>{{ productPrice.price }}</strong> <sup><strong>€</strong> HT</sup></span
            >
          </div>
          <p class="product__price-text">Prix à l'unité</p>
        </div>
      </div>
      <p class="product__code">Code article : {{ item.code }}</p>
      <div class="product__stock-container">
        <div class="product__stock stock">
          Etat du stock
          <div
            v-if="item.productShops[0] && item.productShops[0].stock == 0"
            class="stock__picto magasin red"
          >
            <img src="/static/img/pictos/magasinstockssbulle.svg" alt="" />
          </div>
          <div
            v-else-if="item.productShops[0] && item.productShops[0].stock <= 10"
            class="stock__picto magasin orange"
          >
            <img src="/static/img/pictos/magasinstockssbulle.svg" alt="" />
          </div>
          <div v-else-if="item.productShops[0]" class="stock__picto magasin green">
            <img src="/static/img/pictos/magasinstockssbulle.svg" alt="" />
          </div>
          <span class="stock__number" v-if="item.productShops[0]">{{
            item.productShops[0].stock
          }}</span>
        </div>
      </div>
      <div class="product__btns">
        <router-link
          v-if="item.id"
          :to="{ name: 'ProductDetail', params: { id: item.id } }"
          class="product__btn product__btn--see"
        >
          <img src="/static/img/pictos/flecheblanche.svg" alt="" />
        </router-link>
        <ProductAddToCart :item="item"></ProductAddToCart>
      </div>
    </div>
  </div>
  <div class="products__product product product--mobile" v-else>
    <router-link
      v-if="item.id"
      :to="{ name: 'ProductDetail', params: { id: item.id } }"
      class="product__image-container"
    >
      <img
        class="product__image"
        alt=""
        v-if="item.photos[0]"
        :src="imagesurl + '600/' + item.photos[0].name"
      />
      <img v-else class="product__image" src="/static/img/600x400.jpg" alt="" />
    </router-link>
    <div class="product__info-container">
      <div class="product__info-main">
        <div class="product__name-container">
          <h3 class="product__name">{{ item.label }}</h3>
        </div>
      </div>
      <p class="product__code">
        <img
          src="/static/img/pictos/reapprobleufonce.svg"
          alt=""
          v-if="
            item.vehicleStocks &&
            item.vehicleStocks.length == 1 &&
            item.vehicleStocks[0].restocking == 1
          "
        />
        Code article : {{ item.code }}
      </p>
      <div class="product__stock-container">
        <!-- <p class="product__stock stock">Etat du stock <div class="stock__picto green">
          <img src="/static/img/pictos/magasinstockssbulle.svg" alt="" ></div><span class="stock__number">0</span>
        </p> -->
        <div class="product__stock stock">
          <div
            v-if="
              item.vehicleStocks[0] && item.vehicleStocks[0].stock < item.vehicleStocks[0].minStock
            "
            class="stock__picto red"
          >
            <img src="/static/img/pictos/camionstockssbulle.svg" alt="" />
          </div>
          <div
            v-else-if="
              item.vehicleStocks[0] && item.vehicleStocks[0].stock == item.vehicleStocks[0].minStock
            "
            class="stock__picto orange"
          >
            <img src="/static/img/pictos/camionstockssbulle.svg" alt="" />
          </div>
          <div v-else-if="item.vehicleStocks[0]" class="stock__picto green">
            <img src="/static/img/pictos/camionstockssbulle.svg" alt="" />
          </div>
          <span class="stock__number" v-if="item.vehicleStocks[0]">{{
            item.vehicleStocks[0].stock
          }}</span>

          <div
            v-if="item.productShops[0] && item.productShops[0].stock == 0"
            class="stock__picto magasin red"
          >
            <img src="/static/img/pictos/magasinstockssbulle.svg" alt="" />
          </div>
          <div
            v-else-if="item.productShops[0] && item.productShops[0].stock <= 10"
            class="stock__picto magasin orange"
          >
            <img src="/static/img/pictos/magasinstockssbulle.svg" alt="" />
          </div>
          <div v-else-if="item.productShops[0]" class="stock__picto magasin green">
            <img src="/static/img/pictos/magasinstockssbulle.svg" alt="" />
          </div>
          <span class="stock__number" v-if="item.productShops[0]">{{
            item.productShops[0].stock
          }}</span>
        </div>
      </div>
      <div class="product__btns">
        <router-link
          v-if="item.id"
          :to="{ name: 'ProductDetail', params: { id: item.id } }"
          class="product__btn product__btn--see"
        >
          <img src="/static/img/pictos/flecheblanche.svg" alt="" />
        </router-link>
        <ProductAddToCart :item="item"></ProductAddToCart>
      </div>
    </div>
  </div>
</template>

<script>
import ProductAddToCart from "@/components/Product/ProductAddToCart";

export default {
  name: "Product",
  props: ["item"],
  data() {
    return {};
  },
  components: {
    ProductAddToCart,
  },
  computed: {
    imagesurl() {
      return process.env.BACK_UPLOADS_URL;
    },
    me: function () {
      let me = this.$store.getters["auth/user"];

      if (typeof me == "string") {
        return JSON.parse(me);
      } else {
        return me;
      }
    },
  },
  filters: {
    truncate: function (text, length, suffix) {
      if (text.length > length) {
        return text.substring(0, length) + suffix;
      } else {
        return text;
      }
    },
  },
  mounted() {
    // if(this.item.imagesUrls){
    //   this.imagesUrls = this.item.imagesUrls[0];
    // }
  },
};
</script>


<style lang="scss" scoped>
@import "~@/assets/scss/_colors.scss";

.product {
  display: flex;
  flex-wrap: wrap;
  flex-direction: row;
  position: relative;
  width: calc(50% - 15px);
  border: 1px solid $grisclair;
  height: 240px;
  margin-bottom: 30px;
  &__image-container {
    width: 40%;
    height: 100%;
  }
  &__image {
    width: 100%;
    height: 100%;
    object-fit: cover;
  }
  &__info-container {
    width: 60%;
    height: 100%;
    padding: 40px 0 40px 35px;
    background-color: white;
  }
  &__info-main {
    display: flex;
    flex-wrap: wrap;
    flex-direction: row;
    width: 100%;
    align-items: top;
    .product__name-container {
      width: 50%;
      line-height: 1;
    }
    .product__price-container {
      width: 50%;
      text-align: left;
      line-height: 1;
      padding-left: 20px;
    }
  }
  &__stock-container {
    border-top: 1px solid $color1;
    padding-top: 15px;
    display: flex;
    align-items: last baseline;
  }
  &__name {
    font-size: 15px;
    text-transform: uppercase;
    font-family: "ClanFFBlack";
    color: $mystockblue;
  }
  &__stock {
    text-transform: uppercase;
    font-family: "ClanPro";
    color: $grisfonce;
    font-size: 14px;
  }
  .stock {
    display: flex;
    flex-direction: row;
    width: 100%;
    align-items: center;
    &__number {
      color: $grisfonce;
      font-family: "ClanFFBlack";
      font-size: 15px;
    }
    &__picto {
      margin: 0 10px;
      position: relative;
      &:before {
        content: "";
        display: block;
        width: 12px;
        height: 12px;
        opacity: 0.75;
        position: absolute;
        top: 0;
        left: 0;
        margin-left: -3px;
        margin-top: -3px;
        border-radius: 50%;
      }
      img {
        width: 20px;
        vertical-align: top;
        margin-top: 2px;
      }
      &.green {
        &:before {
          background: $vert;
        }
      }
      &.red {
        &:before {
          background: $rouge;
        }
      }
      &.orange {
        &:before {
          background: $orange;
        }
      }
      &.magasin {
        img {
          width: 16px;
        }
      }
    }
  }

  &__price {
    font-size: 25px;
    color: $color2;
    white-space: nowrap;
    strong {
      font-family: "ClanFFBlack";
      font-weight: normal;
    }
    sup {
      font-size: 10px;
      font-family: "ClanPro";
    }
  }
  &__price-text {
    font-size: 10px;
    font-family: "ClanPro";
    color: $color2;
  }
  &__code {
    font-size: 14px;
    color: $grisfonce;
    font-family: "ClanPro";
  }
  &__btns {
    display: flex;
    flex-wrap: wrap;
    flex-direction: row;
    position: absolute;
    bottom: 0;
    right: 0;
  }
  &__btn {
    width: 80px;
    text-align: center;
    height: 40px;
    color: white;
    line-height: 36px;
    &--see {
      background-color: $color2;
      img {
        width: 16px;
      }
    }
    &--add {
      background-color: $color3;
      img {
        width: 20px;
      }
    }
  }
  &--mobile {
    width: calc(50% - 5px);
    min-width: 0;
    margin-bottom: 10px;
    flex-direction: column;
    height: auto;
    .product__image-container {
      width: 100%;
      height: 200px;
    }
    .product__info-container {
      width: 100%;
      height: auto;
      padding: 10px 0 60px;
    }
    .product__btns {
      width: 100%;
      display: flex;
      .product__btn {
        width: 50%;
        height: 60px;
        line-height: 60px;
        img {
          width: 25px;
        }
      }
    }
    .product__name-container {
      width: 100%;
      .product__name {
        font-size: 16px;
      }
    }
    .product__info-main {
      padding: 10px;
    }
    .product__code {
      padding: 0 10px;
      img {
        width: 20px;
      }
    }
    .product__stock-container {
      padding: 10px;
      .stock {
        margin-bottom: 0;
      }
    }
  }
  &--fullwidth {
    width: 100%;
  }
  &--no-border {
    border: none;
  }
}

@media screen and (max-width: 1500px) {
  .product {
    &__price {
      font-size: 20px;
      white-space: pre-wrap;
    }
    &__info-container {
      padding: 30px 0 40px 20px;
    }
  }
}
@media screen and (max-width: 1300px) {
  .product {
    &__price {
      font-size: 16px;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/Product/Product.vue